export const arrowUp16 = "M8 14V3.74L6.415 5.325l-.707-.707 2.81-2.81 2.808 2.81-.707.707L9 3.705V14z";
